import { BundleProductTile } from "./bundle-product-tile";
import { t } from '@process-creative/slate-theme-tools';

const template = document.createElement('template');
template.innerHTML = `
  <style>
    :host {
      height: 100%;
      overflow: scroll;
    }

    .bundle-product-selector {
      height: 100%;
      display: none;
    }

    .bundle-product-selector.active {
      display: block;
    }

    .title {
      font-size: 1.25rem;
      font-weight: 485;
      line-height: 1.625rem;
      letter-spacing: 0.025rem;
      text-transform: uppercase;
      margin-top: 2.4375rem;
      margin-bottom: 1.75rem;
    }

    .product-list {
      height: 90%;
      overflow-y: auto;
    }
  


  </style>

  <div class="bundle-product-selector" part="product-selector">
    <h2 class="title"></h2>
    <div class="product-list">
      <slot></slot>
    </div>


  </div>
`;

const generateStepTitle = (stepIndex:number) => {
  // Choose 1st Whiskey, Choose 2nd Whiskey etc
  const indexSuffixes = ['st', 'nd', 'rd'];
  const count =  `${stepIndex + 1}${indexSuffixes[stepIndex]}`;
  const choiceLabel = t('products.bundle.builder_option_label').replace('{{ count }}', count);
  return choiceLabel;
};

export class BundleProductSelector extends HTMLElement {
  private stepIsActive:boolean = false;

  private readonly root:HTMLDivElement|null;
  private readonly stepIndex:number = parseInt(this.getAttribute('step-index') || '');

  private readonly titleElement:HTMLElement|null;
  private readonly productTiles:BundleProductTile[];


  constructor() {
    super();
    const shadowRoot = this.attachShadow({ mode: 'open' });
    shadowRoot.appendChild(template.content.cloneNode(true));

    const slotElement = shadowRoot.querySelector('slot');

    this.productTiles = slotElement?.assignedElements() as BundleProductTile[];
    this.titleElement = shadowRoot.querySelector('.title');

    this.root = shadowRoot.querySelector('.bundle-product-selector')!;
    
    if (!this.titleElement) {
      throw Error
    } else {
      this.titleElement.textContent = generateStepTitle(this.stepIndex);
    }

  }

  public setActive(isActive:boolean) {
    this.stepIsActive = isActive;
    this.root!.classList[this.stepIsActive ? 'add' : 'remove']('active');
  }

  public setInactiveTiles() {
    this.productTiles.forEach(tile => tile.setActive(false));
  }

  public loadProduct(variantId:string) {
    const productToLoad = this.productTiles.find(tile => tile.variant.id == variantId);

    if (!productToLoad) {
      return console.warn(`Coudln't load variant #${variantId} on product selector #${this.stepIndex}`)
    }

    productToLoad.handleAddToCartClick();
  }
}

if(!customElements.get('bundle-product-selector')) {
  customElements.define('bundle-product-selector', BundleProductSelector);
}